import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/parking_relief_records',
  component: Management,
  redirect: '/parking_relief_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/parking_relief_records/List'),
      meta: {
        auth: Auth.listParkingReliefRecords
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/parking_relief_records/ListTable'),
          meta: {
            auth: Auth.listParkingReliefRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
